import React from 'react'

const NotFound = () => {
    console.log('Got Here');
  return (
    <div>
      <h1>Not Found</h1>
      <p className="lead">The page you are looking for was not found</p>
    </div>
  )
}

export default NotFound
